import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const API = 'https://legado-digital-production.up.railway.app'

const DOCUMENTOS_DEFAULT = [
  'Testamento',
  'Seguro de vida',
  'Escrituras de la casa',
  'Identificación oficial',
  'Pasaporte',
  'Seguro médico',
  'Contrato de arrendamiento',
  'Declaración de impuestos',
  'Cartilla de vacunación',
  'Poderes notariales',
]

function MiPerfil({ userId, pestanaInicial }) {
  const [pestana, setPestana] = useState(pestanaInicial || 'perfil')
  const [guardando, setGuardando] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')

  const [perfil, setPerfil] = useState({
    nombreCompleto: '', fechaNacimiento: '', identificacion: '',
    direccion: '', telefono: '', medicoCabecera: '', tipoSangre: '',
    contactoEmergencia: '', nacionalidad: '', estadoCivil: '',
    seguridadSocial: '', notas: ''
  })

  const [voluntades, setVoluntades] = useState({
    tipoEntierro: '', tipoEntierroOtro: '', donacionOrganos: null,
    registroDonador: '', tipoFuneral: '', tipoFuneralOtro: '',
    lugarDescanso: '', musica: '', lecturasPersonas: '',
    mensajeFinal: '', testamentoVital: '', abogadoNotario: '',
    infoAdicional: ''
  })

  const [checklist, setChecklist] = useState([])
  const [nuevoDoc, setNuevoDoc] = useState('')
  const [cargando, setCargando] = useState(true)

  useEffect(() => { cargarTodo() }, [userId])

  async function cargarTodo() {
    setCargando(true)
    try {
      const [resPerfil, resVoluntades, resChecklist] = await Promise.all([
        fetch(`${API}/api/perfil?userId=${userId}`),
        fetch(`${API}/api/voluntades?userId=${userId}`),
        fetch(`${API}/api/checklist?userId=${userId}`),
      ])
      const [dataPerfil, dataVoluntades, dataChecklist] = await Promise.all([
        resPerfil.json(), resVoluntades.json(), resChecklist.json()
      ])
      if (dataPerfil.ok && dataPerfil.datos) {
        const d = dataPerfil.datos
        setPerfil({
          nombreCompleto: d.nombre_completo || '',
          fechaNacimiento: d.fecha_nacimiento || '',
          identificacion: d.identificacion || '',
          direccion: d.direccion || '',
          telefono: d.telefono || '',
          medicoCabecera: d.medico_cabecera || '',
          tipoSangre: d.tipo_sangre || '',
          contactoEmergencia: d.contacto_emergencia || '',
          nacionalidad: d.nacionalidad || '',
          estadoCivil: d.estado_civil || '',
          seguridadSocial: d.seguridad_social || '',
          notas: d.notas || '',
        })
      }
      if (dataVoluntades.ok && dataVoluntades.datos) {
        const d = dataVoluntades.datos
        setVoluntades({
          tipoEntierro: d.tipo_entierro || '',
          tipoEntierroOtro: d.tipo_entierro_otro || '',
          donacionOrganos: d.donacion_organos,
          registroDonador: d.registro_donador || '',
          tipoFuneral: d.tipo_funeral || '',
          tipoFuneralOtro: d.tipo_funeral_otro || '',
          lugarDescanso: d.lugar_descanso || '',
          musica: d.musica || '',
          lecturasPersonas: d.lecturas_personas || '',
          mensajeFinal: d.mensaje_final || '',
          testamentoVital: d.testamento_vital || '',
          abogadoNotario: d.abogado_notario || '',
          infoAdicional: d.info_adicional || '',
        })
      }
      if (dataChecklist.ok) setChecklist(dataChecklist.datos)
    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setCargando(false)
    }
  }

  async function guardarPerfil(e) {
    e.preventDefault()
    setGuardando(true)
    setError('')
    try {
      const res = await fetch(`${API}/api/perfil`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, ...perfil }),
      })
      const datos = await res.json()
      if (!datos.ok) { setError(datos.error); return }
      setMensaje('Perfil guardado correctamente.')
      setTimeout(() => setMensaje(''), 4000)
    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setGuardando(false)
    }
  }

  async function guardarVoluntades(e) {
    e.preventDefault()
    setGuardando(true)
    setError('')
    try {
      const res = await fetch(`${API}/api/voluntades`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, ...voluntades }),
      })
      const datos = await res.json()
      if (!datos.ok) { setError(datos.error); return }
      setMensaje('Mis deseos guardados correctamente.')
      setTimeout(() => setMensaje(''), 4000)
    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setGuardando(false)
    }
  }

  async function inicializarChecklist() {
    const existentes = checklist.map(c => c.nombre)
    const nuevos = DOCUMENTOS_DEFAULT.filter(d => !existentes.includes(d))
    for (const nombre of nuevos) {
      await fetch(`${API}/api/checklist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, nombre, personalizado: false }),
      })
    }
    cargarTodo()
  }

  async function toggleCompletado(id, completado) {
    await fetch(`${API}/api/checklist/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ completado: !completado }),
    })
    setChecklist(prev => prev.map(c => c.id === id ? { ...c, completado: !completado } : c))
  }

  async function añadirDocumento() {
    if (!nuevoDoc.trim()) return
    const res = await fetch(`${API}/api/checklist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, nombre: nuevoDoc.trim(), personalizado: true }),
    })
    const datos = await res.json()
    if (datos.ok) {
      setChecklist(prev => [...prev, datos.datos])
      setNuevoDoc('')
    }
  }

  async function eliminarDocumento(id) {
    await fetch(`${API}/api/checklist/${id}`, { method: 'DELETE' })
    setChecklist(prev => prev.filter(c => c.id !== id))
  }

  const completados = checklist.filter(c => c.completado).length

  if (cargando) return <p style={{ textAlign: 'center', color: '#8B6F47', padding: '40px' }}>Cargando...</p>

  return (
    <div style={estilos.pagina} className="pagina-contenido">
      <div style={estilos.contenido}>

        <div style={estilos.header}>
          <h2 style={estilos.titulo}>Mi perfil</h2>
          <p style={estilos.subtitulo}>Tu información personal, tus deseos y tus documentos — todo en un lugar seguro.</p>
        </div>

        <div style={estilos.pestanas}>
          {['perfil', 'deseos', 'checklist'].map(p => (
            <button key={p} onClick={() => { setPestana(p); setMensaje(''); setError('') }}
              style={{ ...estilos.pestana, borderBottom: pestana === p ? '2px solid #2C1810' : '2px solid transparent', color: pestana === p ? '#2C1810' : '#8B6F47', fontWeight: pestana === p ? '600' : '400' }}>
              {p === 'perfil' ? 'Mi perfil' : p === 'deseos' ? 'Mis deseos' : 'Documentos'}
            </button>
          ))}
        </div>

        {mensaje && <div style={estilos.mensajeExito}>{mensaje}</div>}
        {error && <div style={estilos.errorDiv}>{error}</div>}

        {/* MI PERFIL */}
        {pestana === 'perfil' && (
          <form onSubmit={guardarPerfil} style={estilos.formulario}>
            <p style={estilos.formNota}>Todos los campos son opcionales. Rellena solo lo que quieras.</p>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Nombre completo</label>
                <input type="text" value={perfil.nombreCompleto} onChange={e => setPerfil({...perfil, nombreCompleto: e.target.value})} style={estilos.input} placeholder="Tu nombre completo" />
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Fecha de nacimiento</label>
                <input type="date" value={perfil.fechaNacimiento} onChange={e => setPerfil({...perfil, fechaNacimiento: e.target.value})} style={estilos.input} />
              </div>
            </div>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Identificación oficial</label>
                <input type="text" value={perfil.identificacion} onChange={e => setPerfil({...perfil, identificacion: e.target.value})} style={estilos.input} placeholder="DNI, cédula, CURP..." />
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Número de seguridad social</label>
                <input type="text" value={perfil.seguridadSocial} onChange={e => setPerfil({...perfil, seguridadSocial: e.target.value})} style={estilos.input} placeholder="Número de seguridad social" />
              </div>
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Dirección</label>
              <input type="text" value={perfil.direccion} onChange={e => setPerfil({...perfil, direccion: e.target.value})} style={estilos.input} placeholder="Tu dirección completa" />
            </div>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Teléfono</label>
                <input type="text" value={perfil.telefono} onChange={e => setPerfil({...perfil, telefono: e.target.value})} style={estilos.input} placeholder="+34 600 000 000" />
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Nacionalidad</label>
                <input type="text" value={perfil.nacionalidad} onChange={e => setPerfil({...perfil, nacionalidad: e.target.value})} style={estilos.input} placeholder="Tu nacionalidad" />
              </div>
            </div>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Estado civil</label>
                <select value={perfil.estadoCivil} onChange={e => setPerfil({...perfil, estadoCivil: e.target.value})} style={estilos.input}>
                  <option value="">Seleccionar...</option>
                  <option value="soltero">Soltero/a</option>
                  <option value="casado">Casado/a</option>
                  <option value="divorciado">Divorciado/a</option>
                  <option value="viudo">Viudo/a</option>
                  <option value="union_libre">Unión libre</option>
                </select>
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Tipo de sangre</label>
                <select value={perfil.tipoSangre} onChange={e => setPerfil({...perfil, tipoSangre: e.target.value})} style={estilos.input}>
                  <option value="">Seleccionar...</option>
                  {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
            </div>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Médico de cabecera</label>
                <input type="text" value={perfil.medicoCabecera} onChange={e => setPerfil({...perfil, medicoCabecera: e.target.value})} style={estilos.input} placeholder="Nombre y teléfono" />
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Contacto de emergencia</label>
                <input type="text" value={perfil.contactoEmergencia} onChange={e => setPerfil({...perfil, contactoEmergencia: e.target.value})} style={estilos.input} placeholder="Nombre y teléfono" />
              </div>
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Notas adicionales</label>
              <textarea value={perfil.notas} onChange={e => setPerfil({...perfil, notas: e.target.value})} style={{ ...estilos.input, minHeight: '80px', resize: 'vertical' }} placeholder="Cualquier información adicional..." rows={3} />
            </div>
            <button type="submit" disabled={guardando} style={{ ...estilos.boton, opacity: guardando ? 0.7 : 1 }}>
              {guardando ? 'Guardando...' : 'Guardar perfil'}
            </button>
          </form>
        )}

        {/* MIS DESEOS */}
        {pestana === 'deseos' && (
          <form onSubmit={guardarVoluntades} style={estilos.formulario}>
            <p style={estilos.formNota}>Todos los campos son opcionales. Deja indicado solo lo que quieras que sepan.</p>
            <div style={estilos.grid}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Tipo de entierro</label>
                <select value={voluntades.tipoEntierro} onChange={e => setVoluntades({...voluntades, tipoEntierro: e.target.value, tipoEntierroOtro: ''})} style={estilos.input}>
                  <option value="">Seleccionar...</option>
                  <option value="cremacion">Cremación</option>
                  <option value="inhumacion">Inhumación</option>
                  <option value="natural">Entierro natural/ecológico</option>
                  <option value="otro">Otro</option>
                </select>
                {voluntades.tipoEntierro === 'otro' && (
                  <input type="text" value={voluntades.tipoEntierroOtro} onChange={e => setVoluntades({...voluntades, tipoEntierroOtro: e.target.value})} style={{ ...estilos.input, marginTop: '8px' }} placeholder="Especifica el tipo de entierro..." />
                )}
              </div>
              <div style={estilos.campo}>
                <label style={estilos.label}>Tipo de funeral</label>
                <select value={voluntades.tipoFuneral} onChange={e => setVoluntades({...voluntades, tipoFuneral: e.target.value, tipoFuneralOtro: ''})} style={estilos.input}>
                  <option value="">Seleccionar...</option>
                  <option value="religioso">Religioso</option>
                  <option value="civil">Civil / laico</option>
                  <option value="privado">Privado / íntimo</option>
                  <option value="sin_funeral">Sin funeral</option>
                  <option value="otro">Otro</option>
                </select>
                {voluntades.tipoFuneral === 'otro' && (
                  <input type="text" value={voluntades.tipoFuneralOtro} onChange={e => setVoluntades({...voluntades, tipoFuneralOtro: e.target.value})} style={{ ...estilos.input, marginTop: '8px' }} placeholder="Especifica el tipo de funeral..." />
                )}
              </div>
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Donación de órganos</label>
              <div style={estilos.radioGrupo}>
                {[{ val: true, label: 'Sí, deseo donar mis órganos' }, { val: false, label: 'No deseo donar mis órganos' }, { val: null, label: 'No especificado' }].map(op => (
                  <label key={String(op.val)} style={estilos.radioLabel}>
                    <input type="radio" name="donacion" checked={voluntades.donacionOrganos === op.val} onChange={() => setVoluntades({...voluntades, donacionOrganos: op.val})} />
                    <span style={{ marginLeft: '8px' }}>{op.label}</span>
                  </label>
                ))}
              </div>
              {voluntades.donacionOrganos === true && (
                <input type="text" value={voluntades.registroDonador} onChange={e => setVoluntades({...voluntades, registroDonador: e.target.value})} style={{ ...estilos.input, marginTop: '10px' }} placeholder="Número de registro, tarjeta de donador o dónde se encuentra..." />
              )}
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Lugar de descanso</label>
              <input type="text" value={voluntades.lugarDescanso} onChange={e => setVoluntades({...voluntades, lugarDescanso: e.target.value})} style={estilos.input} placeholder="Ej: Cementerio de mi ciudad, dispersión de cenizas en el mar..." />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Música</label>
              <input type="text" value={voluntades.musica} onChange={e => setVoluntades({...voluntades, musica: e.target.value})} style={estilos.input} placeholder="Canciones o tipo de música que te gustaría" />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Lecturas o personas que quieres que hablen</label>
              <textarea value={voluntades.lecturasPersonas} onChange={e => setVoluntades({...voluntades, lecturasPersonas: e.target.value})} style={{ ...estilos.input, minHeight: '80px', resize: 'vertical' }} placeholder="Personas, textos o lecturas que deseas incluir" rows={3} />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Directivas anticipadas</label>
              <textarea value={voluntades.testamentoVital} onChange={e => setVoluntades({...voluntades, testamentoVital: e.target.value})} style={{ ...estilos.input, minHeight: '80px', resize: 'vertical' }} placeholder="Instrucciones médicas en caso de incapacidad temporal o permanente..." rows={3} />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Abogado o notario de confianza</label>
              <input type="text" value={voluntades.abogadoNotario} onChange={e => setVoluntades({...voluntades, abogadoNotario: e.target.value})} style={estilos.input} placeholder="Nombre y contacto" />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Mensaje para quienes estén presentes</label>
              <textarea value={voluntades.mensajeFinal} onChange={e => setVoluntades({...voluntades, mensajeFinal: e.target.value})} style={{ ...estilos.input, minHeight: '100px', resize: 'vertical' }} placeholder="Palabras que quieres que lean quienes estén presentes..." rows={4} />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Información adicional</label>
              <textarea value={voluntades.infoAdicional} onChange={e => setVoluntades({...voluntades, infoAdicional: e.target.value})} style={{ ...estilos.input, minHeight: '80px', resize: 'vertical' }} placeholder="Cualquier otro deseo que quieras dejar registrado..." rows={3} />
            </div>
            <button type="submit" disabled={guardando} style={{ ...estilos.boton, opacity: guardando ? 0.7 : 1 }}>
              {guardando ? 'Guardando...' : 'Guardar mis deseos'}
            </button>
          </form>
        )}

        {/* DOCUMENTOS */}
        {pestana === 'checklist' && (
          <div style={estilos.formulario}>
            <p style={estilos.formNota}>Marca los documentos que ya tienes localizados y en orden.</p>
            {checklist.length > 0 && (
              <div style={estilos.progreso}>
                <div style={estilos.progresoTexto}>{completados} de {checklist.length} documentos listos</div>
                <div style={estilos.progresoBar}>
                  <div style={{ ...estilos.progresoRelleno, width: `${checklist.length ? (completados / checklist.length) * 100 : 0}%` }} />
                </div>
              </div>
            )}
            {checklist.length === 0 && (
              <div style={estilos.checklistVacio}>
                <p style={{ color: '#8B6F47', fontSize: '14px', marginBottom: '16px' }}>Empieza con nuestra lista sugerida de documentos importantes.</p>
                <button onClick={inicializarChecklist} style={estilos.boton}>Cargar lista sugerida</button>
              </div>
            )}
            <div style={estilos.checklistItems}>
              {checklist.map(doc => (
                <div key={doc.id} style={estilos.checkItem}>
                  <label style={estilos.checkLabel}>
                    <input type="checkbox" checked={doc.completado} onChange={() => toggleCompletado(doc.id, doc.completado)} style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#2C1810' }} />
                    <span style={{ ...estilos.checkTexto, textDecoration: doc.completado ? 'line-through' : 'none', color: doc.completado ? '#C4A882' : '#2C1810' }}>
                      {doc.nombre}
                      {doc.personalizado && <span style={estilos.badgePersonal}>personalizado</span>}
                    </span>
                  </label>
                  {doc.personalizado && <button onClick={() => eliminarDocumento(doc.id)} style={estilos.btnEliminar}>✕</button>}
                </div>
              ))}
            </div>
            <div style={estilos.añadirDoc}>
              <input type="text" value={nuevoDoc} onChange={e => setNuevoDoc(e.target.value)} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), añadirDocumento())} style={estilos.input} placeholder="Añadir documento personalizado..." />
              <button onClick={añadirDocumento} style={estilos.botonAñadir}>Añadir</button>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: 'calc(100vh - 64px)', backgroundColor: '#FAF8F5', padding: '32px 16px', scrollMarginTop: '56px' },
  contenido: { maxWidth: '700px', margin: '0 auto' },
  header: { marginBottom: '24px' },
  titulo: { fontSize: '24px', fontWeight: '700', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  subtitulo: { fontSize: '14px', color: '#8B6F47', lineHeight: '1.7' },
  pestanas: { display: 'flex', borderBottom: '2px solid #E8E0D5', marginBottom: '20px', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' },
  pestana: { padding: '10px 16px', backgroundColor: 'transparent', border: 'none', fontSize: '14px', cursor: 'pointer', borderBottom: '2px solid transparent', marginBottom: '-2px', whiteSpace: 'nowrap' },
  mensajeExito: { backgroundColor: '#F0F4E8', color: '#3D4D1F', padding: '12px 16px', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', border: '1px solid #C8D5A0' },
  errorDiv: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', border: '1px solid #F5C9B8' },
  formulario: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '24px', border: '1px solid #E8E0D5' },
  formNota: { fontSize: '13px', color: '#8B6F47', marginBottom: '20px', fontStyle: 'italic' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { marginBottom: '16px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '500', color: '#2C1810', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '14px', outline: 'none', backgroundColor: '#FAF8F5', color: '#2C1810', fontFamily: 'inherit' },
  boton: { width: '100%', padding: '13px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  radioGrupo: { display: 'flex', flexDirection: 'column', gap: '8px' },
  radioLabel: { display: 'flex', alignItems: 'center', fontSize: '14px', color: '#2C1810', cursor: 'pointer' },
  progreso: { marginBottom: '20px' },
  progresoTexto: { fontSize: '13px', color: '#8B6F47', marginBottom: '6px' },
  progresoBar: { height: '6px', backgroundColor: '#E8E0D5', borderRadius: '3px', overflow: 'hidden' },
  progresoRelleno: { height: '6px', backgroundColor: '#5C6B3A', borderRadius: '3px', transition: 'width 0.3s ease' },
  checklistVacio: { textAlign: 'center', padding: '20px 0' },
  checklistItems: { display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '20px' },
  checkItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', borderRadius: '8px', backgroundColor: '#FAF8F5', border: '1px solid #E8E0D5' },
  checkLabel: { display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', flex: 1 },
  checkTexto: { fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' },
  badgePersonal: { fontSize: '10px', backgroundColor: '#F0EAE0', color: '#8B6F47', padding: '2px 8px', borderRadius: '10px', fontStyle: 'normal' },
  btnEliminar: { backgroundColor: 'transparent', border: 'none', color: '#C4A882', fontSize: '16px', cursor: 'pointer', padding: '0 4px' },
  añadirDoc: { display: 'flex', gap: '8px', marginTop: '8px' },
  botonAñadir: { padding: '10px 20px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap' },
}

export default MiPerfil